import React from "react";
import Explorer from "../../../data-containers/explorer";

function TabSummary() {
  const { getActiveLocations, getInactiveLocations, getAvailableHubs } =
    Explorer.useContainer();
  const active = getActiveLocations();
  const inActive = getInactiveLocations();
  const inventory = getAvailableHubs();

  return (
    <div className="tab-summary-container">
      <div className="tab-data-container border-right">
        <div className="tab-type">Inventory</div> &nbsp;{" "}
        <div className="data-number">{inventory?.count || "0"}</div>
      </div>

      <div className="tab-data-container ">
        <div className="tab-type">Active</div> &nbsp;{" "}
        <div className="data-number">{active?.count || "0"}</div>
      </div>

      <div className="tab-data-container border-left">
        <div className="tab-type">Inactive</div> &nbsp;{" "}
        <div className="data-number">{inActive?.count || "0"}</div>
      </div>
    </div>
  );
}

export default TabSummary;
